import { formatAddress as renderAddress } from "../helpers/address";

export const categories = ["wool", "silk", "synthetic"];

const hoursAgo = (hours) => new Date(Date.now() - hours * 60 * 60 * 1000).toISOString();

export function createInitialState() {
  return {
    nextRef: 22,
    nextClientRef: 1109,
    nextId: 100,
    priceCalculator: [
      { clientItemCategory: "wool", algorithm: "(dimensions.length / 100) * (dimensions.width / 100) * 12" },
      { clientItemCategory: "silk", algorithm: "(dimensions.length / 100) * (dimensions.width / 100) * 25" },
    ],
    clients: [
      {
        id: "c1",
        ref: "1042",
        firstName: "Μαρία",
        lastName: "Παπαδοπούλου",
        phone: "99 112233",
        address: { street: "Λεωφ. Στροβόλου 12", unit: "Διαμ. 4", city: "Λευκωσία", zip: "2034" },
      },
      {
        id: "c2",
        ref: "1108",
        firstName: "Ανδρέας",
        lastName: "Ιωάννου",
        phone: "96 445566",
        address: { street: "Αρχ. Μακαρίου 88", city: "Λεμεσός", zip: "3020" },
      },
      {
        id: "c3",
        ref: "980",
        firstName: "Ελένη",
        lastName: "Χρίστου",
        phone: "97 778899",
        address: { street: "Γρίβα Διγενή 5", city: "Λάρνακα", zip: "6021" },
      },
    ],
    carpets: [
      { id: "p12", ref: "12", clientId: "c1", category: "wool", length: 300, width: 200, description: "Κόκκινο κλασικό", price: 72 },
      { id: "p18", ref: "18", clientId: "c1", category: "silk", length: 200, width: 150, description: "Μπεζ", price: 75 },
      { id: "p7", ref: "7", clientId: "c2", category: "synthetic", length: 250, width: 180, description: "", price: 40 },
      { id: "p4", ref: "4", clientId: "c2", category: "wool", length: 400, width: 300, description: "Σκούρο μπλε", price: 144 },
      { id: "p21", ref: "21", clientId: "c3", category: "wool", length: 180, width: 120, description: "Διάδρομος", price: 25.92 },
    ],
    stays: [
      { id: "s1", carpetId: "p12", clientId: "c1", inAt: hoursAgo(30), outAt: null, storageBox: "A-12", inNotes: "Μπογιά στην άκρη", outNotes: "", cleaned: false, jobPrice: null },
      { id: "s2", carpetId: "p18", clientId: "c1", inAt: hoursAgo(30), outAt: null, storageBox: "B-3", inNotes: "", outNotes: "", cleaned: true, jobPrice: 90 },
      { id: "s3", carpetId: "p7", clientId: "c2", inAt: hoursAgo(6), outAt: null, storageBox: "A-12", inNotes: "", outNotes: "", cleaned: false, jobPrice: null },
      { id: "s4", carpetId: "p4", clientId: "c2", inAt: hoursAgo(200), outAt: hoursAgo(20), storageBox: "C-1", inNotes: "Σκούρος λεκές", outNotes: "Έτοιμο", cleaned: true, jobPrice: 160 },
      { id: "s5", carpetId: "p21", clientId: "c3", inAt: hoursAgo(80), outAt: hoursAgo(10), storageBox: "", inNotes: "", outNotes: "", cleaned: true, jobPrice: null },
    ],
  };
}

export const clientName = (client) =>
  client ? `${client.firstName} ${client.lastName}` : "";

export const money = (value) => (value == null || value === "" ? "" : `€${value}`);

export const dimensionsText = (carpet) => {
  if (!carpet || (carpet.length == null && carpet.width == null)) return "";
  return `${carpet.width || "–"} × ${carpet.length || "–"} cm`;
};

export const formatAddress = renderAddress;

export const openStayFor = (state, carpetId) =>
  state.stays.find((stay) => stay.carpetId === carpetId && !stay.outAt);

export const findClient = (state, id) => state.clients.find((client) => client.id === id);

export const findCarpet = (state, id) => state.carpets.find((carpet) => carpet.id === id);

export const carpetByRef = (state, ref) =>
  state.carpets.find((carpet) => String(carpet.ref) === String(ref).trim());
